// src/data.js

export const projects = [

  {
    title: "Current Portfolio Website",
    subtitle: "React + TailwindCSS",
    description:
    "I have developed a dedicated domain for my React application, which serves as a comprehensive platform to showcase my recent skills, projects, and resume.",
    image: "./react.jpochetedmead.gif",
    link: "https://github.com/jpochetedmead/react-portfolio-website",
    technologies: ["JavaScript", "HTML", "CSS"],
  },

  {
    title: "Edmead Notary Services",
    subtitle: "Wordpress Website",
    description:
    "I was tasked with developing a WordPress website for a Florida-based business that provides public notary services.",
    image: "./edmeadnotaryservices.gif",
    link: "https://edmeadnotaryservices.com/",
    technologies: ["Wordpress", "HTML", "CSS", "PHP"],
  },

  {
    title: "eCommerce Website",
    subtitle: "PHP + TailwindCSS",
    description:
    "CSET 280 - Capstone Project: The objective of this project was to simulate the process of a real-world agency by planning, designing, and developing a functional web application based on client requirements and predefined workflows established by the employer. Collaborating with my team members, we successfully constructed an E-commerce Store utilizing PHP, HTML5, CSS3, TailwindCSS, and MySQL.",
    image: "./eCommerce-pic.png",
    link: "https://github.com/jpochetedmead/Ecommerce-Project",
    technologies: ["PHP", "HTML", "CSS", "TailwindCSS", "MySQL"],

  },

  {
    title: "Elderly Care Management System",
    subtitle: "PHP + Bootstrap",
    description:
    "During this project, my team and I leveraged PHP as the back-end language, PHPMyAdmin as the database management system, and employed HTML5, CSS3, Bootstrap, Git, and GitHub to construct a retirement home web application and API. The primary objective was to gain proficiency in PHP development and reinforce our understanding of the PHP language. The project spanned over 4 weeks, during which we adopted an Agile/Scrum workflow to facilitate our progress.",
    image: "./doctor-visiting-senior.jpg",
    link: "https://github.com/jpochetedmead/Elderly-Care-Management-System",
    technologies: ["PHP", "HTML", "CSS", "Bootstrap", "MySQL"],

  },

  {
    title: "Retro Games Collection",
    subtitle: "Python & JavaScript: Games",
    description:
    "During our second semester, we embarked on our culminating project which aimed to integrate both front-end and back-end development skills. As a team, we successfully created a compilation of classic retro games, including Duck Hunt, Snake, Space Invaders, and Asteroids, and incorporated them into a dynamic website. The website allowed users to create personalized accounts, enabling them to store and retrieve their high scores for each game they played.",
    image: "./retro-games.avif",
    link: "https://github.com/jpochetedmead/RetroGamesCollection",
    technologies: ["Python", "JavaScript", "CSS", "HTML"],

  },

  {
    title: "Escape The Curse Of Chucky",
    subtitle: "Python: Text Adventure Game",
    description:
    "I utilized Python3 and employed Object-Oriented Programming (OOP) principles in this Flask project to create a fast-paced Terminal/Command-line text-adventure game. Within the game, you find yourself in a perilous situation, pursued by the malevolent Chucky, where every decision you make carries the potential to determine your fate. The rules are straightforward: Survive at all costs.",
    image: "./Chucky-Game.jpg",
    link: "https://github.com/jpochetedmead/Flask-Adventure-Game",
    technologies: ["Python", "HTML", "CSS", "TSQL"],
  },

  {
    title: "To-Do App",
    subtitle: "Flask",
    description:
    "During my freshman year in 2019, I was assigned this project as a precursor to the final project. The objective was to develop a basic API capable of creating, updating, deleting, and managing to-do lists. The technology stack utilized for this assignment included Flask, PostgreSQL, Vanilla CSS3, HTML5, and Github for version control. The given timeframe for completing this task was one week.",
    image: "./todo-list.png",
    link: "https://github.com/jpochetedmead/flask-todo",
    technologies: ["Python", "HTML", "CSS", "TSQL"],
  },

  {
    title: "Space Invaders",
    subtitle: "JavaScript Game",
    description:
    "This project served as the culmination of our first semester as developers. We successfully designed, built, and deployed a game, employing all the skills and technologies we have acquired thus far. Moreover, we adhered to a contemporary development workflow throughout the entire process.",
    image: "./space-invaders.gif",
    link: "https://github.com/jpochetedmead/Space-Invaders-Game-Project",
    technologies: ["JavaScript", "CSS", "HTML"],
  },

  {
    title: "TicTacToe",
    subtitle: "JavaScript",
    description:
    "I was given a week to develop a fully functional TicTacToe game. This project marked my first venture into creating a JavaScript ES6 application. The technology stack employed for this project consisted of JavaScript, HTML, and CSS3. This experience enabled me to gain proficiency in Basic JS and the Document Object Model (DOM).",
    image: "./tic-tac-toe.png",
    link: "https://github.com/jpochetedmead/Tic-Tac-Toe-Game",
    technologies: ["JavaScript", "CSS", "HTML"],
  },

  {
    title: "My First Portfolio Website",
    subtitle: "HTML5 & CSS3",
    description:
    "This portfolio project served as my initial significant assignment during my time at Thaddeus Stevens College of Technology. Its objectives were to construct an attractive and fully functional website utilizing HTML5 and CSS3.",
    image: "./first-portfolio.png",
    link: "https://github.com/jpochetedmead/jpochetedmead.github.io",
    technologies: ["CSS", "HTML", "JavaScript"],
  },

];

export const testimonials = [

  {
    quote:
    "Overall, Julio Pochet Edmead is an excellent candidate for computer software engineering positions. With strong technical skills, a collaborative nature, and a commitment to continuous learning, Julio has all the qualities necessary to excel in this field. I wholeheartedly recommend Julio for his valuable contributions to any organization.",
    image: "https://media.licdn.com/dms/image/D4E03AQEyjdqDxEmCmw/profile-displayphoto-shrink_100_100/0/1672253070830?e=1691020800&v=beta&t=hMxBlBpaW9G5N5bJffQJY5vh4nmM-65U0rXRirePTuc",
    name: "Arafat Hassan",
    company: "Edooket",
    position: "Founder & CEO",
  },

  {
    quote:
    "Julio is very hardworking and focused in his work. With his deep Programming knowledge, communication, and excellent technical approach he always delivers innovative solutions for even the most complex business requirements. His humility and affability inspire me and have won the respect of all. Always innovative and hungry for knowledge. Never gives up quickly. Personally a very genuine person. He has a lot of energy and also possesses a lot of potential to grow further in his career. I wish him all the success in his career.",
    image: "https://media.licdn.com/dms/image/D5603AQGqGrHjtiXYow/profile-displayphoto-shrink_100_100/0/1664458914293?e=1691020800&v=beta&t=ZWKMPMGnvggvGhOoYmO4w2ffB_cPPMbcfaGUZMoD7Cs",
    name: "Dinesh Kumar",
    company: "Coforge",
    position: "Technical Specialist",
  },

  {
    quote:
    "Hardworking proficient developer who's an excellent team player and has great potential.",
    //image: "https://randomuser.me/api/portraits/men/1.jpg",
    image: "https://media.licdn.com/dms/image/D4E03AQEko9AlOrvqqw/profile-displayphoto-shrink_100_100/0/1670788979601?e=1691020800&v=beta&t=qCptr3k1l3ZDru0k3ITSl0RprsSw6VwLR4xysaVCwP0",
    name: "Charles Crandall",
    company: "Kleen-Rite Corp.",
    position: "Web Developer",  
  },

  {
    quote:
    "I highly recommend Julio Pochet Edmead for web development projects. Julio recently developed a website for my notary services business, and I was thoroughly impressed. His communication, knowledge, and fast delivery were exceptional. I confidently endorse Julio to future employers or clients seeking a talented web developer.",
    image: "https://media.licdn.com/dms/image/D4E03AQH4p75IGUJrcQ/profile-displayphoto-shrink_100_100/0/1682513931876?e=1691020800&v=beta&t=_0B0UD6h-hRGOAbVaS28riK--SCSX6BTqtqoEAAh0GA",
    name: "Myrna Garcia",
    company: "Edmead Notary Services LLC.",
    position: "Owner",
  },

  {
    quote:
    "I highly recommend Julio Pochet as a web developer. Julio created my personal website, and I am absolutely thrilled with the outcome. His expertise in software development and digital marketing is evident in the quality of his work. Moreover, Julio is a passionate and dedicated entrepreneur, which translates into his proactive approach and ability to overcome challenges. His professionalism, creativity, and attention to detail make him an excellent collaborator. If you are in need of a reliable and talented web developer, do not hesitate to enlist Julio Pochet's services.",
    image: "https://media.licdn.com/dms/image/D4E03AQFwvv7AC-KOiQ/profile-displayphoto-shrink_100_100/0/1677034738675?e=1691020800&v=beta&t=Xw-e74BKSUdIZdeZVcEhXqt8jOeK9rXxS_X_wFXL5Cs",
    name: "Yismerlin Peña",
    company: "Doctor Ney Arias Lora Traumatology Hospital",
    position: "User Support Assistant",  
  },

   {
    quote:
    "Excellent professional.",
    image: "https://media.licdn.com/dms/image/C4E03AQFFwdyWPZ6aRA/profile-displayphoto-shrink_100_100/0/1541074925332?e=1691020800&v=beta&t=mX4v665eVH5cZ2z0cHvG1sxrj4URBOjiIwn1IUTvSME",
    name: " Víctor Figueroa",
    company: "Opti Express Laboratory",
    position: "Storekeeper",
  },

];

export const skills = [

  "HTML",
  "CSS",

  "Bootstrap",
  "TailwindCSS",

  "JavaScript",
  "React",

  "PHP",
  "Laravel",

  "Python3",
  "Flask",

  "Java",
  "Selenium Web Driver",

  "Dart",
  "Flutter",

  "C#",
  "XAMPP",

  "SQL",
  "SQLite",

  "MySQL",
  "PostgreSQL",

  "MongoDB",
  "MS SQL",
  
  "Git",
  "GitHub",

  "Heroku",
  "Firebase",

  "AWS",
  "Netfily",

  "Docker",
  "Wordpress",

  "Agile Project Management",
  "Microsoft Office",

  "Digital Marketing",
  "Logo Design",

  "Facebook Ads",
  "Google Ads",

  "Problem Solving",
  "Communication"

];



// WEBPACK FOOTER //
// ./src/data.js